export async function fetchItemOptionsApi() {
  const data = (await import("./itemoptions.json")).default;
  return data;
}
